import {
  Box,
  Flex,
  HStack,
  Image,
  Text,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { useRouter } from "next/router";

const PostList = ({ data }) => {
  const router = useRouter();
  return (
    <>
      <Wrap spacing="24px">
        {data.map((post) => {
          return (
            <WrapItem
              pb={{ base: "24px", md: "40px" }}
              w={{ base: "100%", md: "calc((100% - 72px) / 3)" }}
              key={post.ID}
              borderBottom={{
                base: "1px solid rgba(0, 0, 0, .1)",
                md: "0px",
              }}
              cursor="pointer"
              onClick={() => {
                delete router.query["post_id_name"];
                router.push({
                  pathname: `/blog/${post.ID}`,
                  query: router.query,
                });
              }}
            >
              <Flex flexDir={{ base: "row", md: "column" }}>
                <Image
                  borderRadius="8px"
                  alt="img"
                  src={post.thumbnail}
                  h={{ base: "105px", md: "300px" }}
                  w={{ base: "105px", md: "100%" }}
                  objectFit="cover"
                  objectPosition="center"
                />
                <Box
                  ml={{ base: "16px", md: "0px" }}
                  mt={{ base: "0px", md: "16px" }}
                >
                  <HStack mt={{ base: "4px", md: "0px" }}>
                    {post.terms.map((term) => (
                      <Text
                        color="#748598"
                        mr="4px"
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        key={term.term_id}
                      >
                        {term.name}
                      </Text>
                    ))}
                  </HStack>
                  <Text
                    mt="4px"
                    color="#333333"
                    fontSize="16px"
                    fontWeight="700"
                    lineHeight="24px"
                  >
                    {post.post_title}
                  </Text>
                  <Text
                    mt="4px"
                    color="#748598"
                    fontSize="14px"
                    fontWeight="400"
                    lineHeight="22px"
                  >
                    {post.post_date}
                  </Text>
                </Box>
              </Flex>
            </WrapItem>
          );
        })}
      </Wrap>
    </>
  );
};
export default PostList;
